import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';

GlobalWorkerOptions.workerSrc = 'assets/pdfjs/pdf.worker.min.mjs';

export async function generatePdfThumbnail(file: File, maxWidth = 240): Promise<string> {
  const pdf = await getDocument({ data: await file.arrayBuffer() }).promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 1 });
  const scale = maxWidth / viewport.width;
  const scaledViewport = page.getViewport({ scale });

  const canvas = document.createElement('canvas');
  canvas.width = Math.floor(scaledViewport.width);
  canvas.height = Math.floor(scaledViewport.height);

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Unable to create PDF thumbnail canvas');
  }

  await page.render({ canvasContext: context, viewport: scaledViewport }).promise;
  return canvas.toDataURL('image/jpeg', 0.82);
}
